import React, { useEffect, useRef, useState } from "react";
import { SelectProps } from "./search-select.types";
import {
  StyledSearchInput,
  SelectDiv,
  StyledOption,
  OptionContainer,
  SearchSelectIcon,
  SearchSelectInputWrapper
} from "./search-select.styles";
import { FieldError } from "../field-error/field-error";
import { Label } from "../label/label";
import { useController } from "react-hook-form";
import { useClickOutside } from "hooks/use-click-outside/use-click-outside";
import { Search } from "components/icons/search";

const SearchSelect = <T extends Record<string, string | boolean>>({
  options,
  name,
  placeholder,
  label,
  control,
  onChange,
  selectedOptionFromListCallback,
  iconToRender,
  textInputCallback,
  testId
}: SelectProps<T>): JSX.Element => {
  const { field, fieldState } = useController({
    name,
    control
  });
  const { error } = fieldState;
  const [showOption, setShowOption] = useState(false);
  const [initialOptions, setOptions] =
    useState<{ name: string; value: string }[]>(options);

  const ref = useRef(null);

  useEffect(() => {
    if (initialOptions) {
      setOptions(options);
    }
  }, [field.value]);

  useClickOutside(ref, () => {
    setShowOption(false);
  });

  return (
    <SelectDiv>
      {label && <Label id={name}>{label}</Label>}

      <SearchSelectInputWrapper>
        <StyledSearchInput
          placeholder={placeholder}
          data-testid={testId}
          {...field}
          {...fieldState}
          // @ts-expect-error
          onChange={(e) => {
            // @ts-expect-error
            textInputCallback && textInputCallback(e.target?.value);
            field.onChange(e);
            setShowOption(true);
            if (onChange) {
              onChange();
            }
          }}
        />
        <SearchSelectIcon>
          {iconToRender ? iconToRender : <Search width="100%" height="100%" />}
        </SearchSelectIcon>
      </SearchSelectInputWrapper>

      {initialOptions && showOption && (
        <OptionContainer ref={ref}>
          {initialOptions.map((option) => {
            return (
              <StyledOption
                onClick={() => {
                  field.onChange(option.name);
                  selectedOptionFromListCallback &&
                    selectedOptionFromListCallback(option.name);
                  setShowOption(false);
                }}
                key={option.value}>
                {option.name}
              </StyledOption>
            );
          })}
        </OptionContainer>
      )}

      {error?.message && <FieldError message={error.message} />}
    </SelectDiv>
  );
};

export { SearchSelect };
